module.exports = __webpack_public_path__ + "assets/collaboration_white.2aa7b09e.svg";